module.exports = __webpack_public_path__ + "img/whatsapp.a5c4ea21.svg";